import { render, staticRenderFns } from "./orderTabFirst.vue?vue&type=template&id=d88e1438"
import script from "./orderTabFirst.vue?vue&type=script&lang=js"
export * from "./orderTabFirst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports